<template>
    <ag-grid-vue style="width: 1000px; height: 500px;"
                 class="ag-theme-balham"
                 :columnDefs="columnDefs"
                 :rowData="rowData">
    </ag-grid-vue>
</template>
<script>
import {AgGridVue} from "ag-grid-vue";

export default {
  name: 'Agg',
  components: {
    AgGridVue
  },
  data() {
    return {
      topGridOptions: null,
      gridApi: null,
      columnApi: null,
      columnDefs: null,
                rowData: null,
                defaultColDef: null,
                pinnedTopRowData: null,
                pinnedBottomRowData: null
            }
        },
        mounted() {
            this.gridApi = this.topGridOptions.api;
            this.gridColumnApi = this.topGridOptions.columnApi;
        },
        beforeMount() {
            this.gridOptions = {};
            this.columnDefs = [
                {
                    headerName: 'Month', field: 'make', pinned: "left",
                    lockPinned: true,
                    width: 100
                },
                {
                    headerName: 'Year', field: 'model', pinned: "left",
                    lockPinned: true,
                    width: 100
                },
                {headerName: 'Solar Production(kWh) Winery', field: 'sp'},
                {headerName: 'Electric Meter 1(kWh) Winery', field: 'em1'},
                {headerName: 'Electric Meter 2(kWh) Winery', field: 'em2'},
                {headerName: 'Electric Meter 3(kWh) Winery', field: 'em3'}
            ];

            this.rowData = [
                {make: 'March', model: '2019', sp: 35000, em1: 6545, em2: 24453, em3: 44567},
                {make: 'April', model: '2019', sp: 35000, em1: 6545, em2: 24453, em3: 44567},
                {make: 'May', model: '2019', sp: 35000, em1: 6545, em2: 24453, em3: 44567},
                {make: 'June', model: '2019', sp: 35000, em1: 6545, em2: 24453, em3: 44567},
                {make: 'July', model: '2019', sp: 32000, em1: 9545, em2: 24153, em3: 89798},
                {make: 'August', model: '2019', sp: 72000, em1: 8545, em2: 34453, em3: 76456}
            ];

            this.defaultColDef = {
                editable: true,
                resizable: true
            };

            this.pinnedTopRowData = getPinnedTopData();
            this.pinnedBottomRowData = getPinnedBottomData();
        },
        onBtStopEditing() {
            this.gridApi.stopEditing();
        },
        onBtStartEditing(key, char, pinned) {
            this.gridApi.setFocusedCell(0, "lastName", pinned);
            this.gridApi.startEditingCell({
                rowIndex: 0,
                colKey: "lastName",
                rowPinned: pinned,
                keyPress: key,
                charPress: char
            });
        },
        onBtNextCell() {
            this.gridApi.tabToNextCell();
        },
        onBtPreviousCell() {
            this.gridApi.tabToPreviousCell();
        },
        onBtWhich() {
            let cellDefs = this.gridApi.getEditingCells();
            if (cellDefs.length > 0) {
                var cellDef = cellDefs[0];
                console.log(
                    "editing cell is: row = " +
                    cellDef.rowIndex +
                    ", col = " +
                    cellDef.column.getId() +
                    ", floating = " +
                    cellDef.floating
                );
            } else {
                console.log("no cells are editing");
            }
        },
        onGridReady(params) {
            params.api.sizeColumnsToFit();
        }

    }

    function getPinnedTopData() {
        return [
            {
                firstName: "##",
                lastName: "##",
                gender: "##",
                address: "##",
                mood: "##",
                country: "##"
            }
        ];
    }

    function getPinnedBottomData() {
        return [
            {
                firstName: "##",
                lastName: "##",
                gender: "##",
                address: "##",
                mood: "##",
                country: "##"
            }
        ];
    }

    function getCharCodeFromEvent(event) {
        event = event || window.event;
        return typeof event.which === "undefined" ? event.keyCode : event.which;
    }

    function isCharNumeric(charStr) {
        return !!/\d/.test(charStr);
    }

    function isKeyPressedNumeric(event) {
        var charCode = getCharCodeFromEvent(event);
        var charStr = String.fromCharCode(charCode);
        return isCharNumeric(charStr);
    }
</script>

<style lang="scss">
    @import "../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
    @import "../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
</style>
